import { FC, useState } from "react";
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@mui/material";
import { Add, DeleteForever, Description, GppGood } from "@mui/icons-material";
import CreateGameWizard from "@components/dialogs/CreateGameWizard";
import { PdfData } from "@/models/pdfData";
import { Views } from "@/models/gameGeneral";
import ValidateGamesDialog from "@components/dialogs/ValidateGamesDialog";
import DeleteEverythingDialog from "@components/dialogs/DeleteEverythingDialog";

const style = {
  margin: 0,
  top: "auto",
  right: 20,
  bottom: 20,
  left: "auto",
  position: "fixed",
};

const FabSpeeddial: FC<{
  onCreateGame: (game: PdfData, destination: Views) => void;
  onCreateEmpty: () => void;
}> = ({ onCreateGame, onCreateEmpty }) => {
  const [openWizard, setOpenWizard] = useState(false);
  const [openValidation, setOpenValidation] = useState(false);
  const [openDeleteEverything, setOpenDeleteEverything] = useState(false);

  const handleCloseWizard = () => setOpenWizard(false);
  const handleOpenWizard = () => setOpenWizard(true);

  const handleOpenValidation = () => setOpenValidation(true);
  const handleCloseValidation = () => setOpenValidation(false);

  const handleOpenDeleteEverything = () => setOpenDeleteEverything(true);
  const handleCloseDeleteEverything = () => setOpenDeleteEverything(false);

  return (
    <>
      <SpeedDial
        color="secondary"
        sx={style}
        ariaLabel={"SpeedDial"}
        icon={<SpeedDialIcon />}
      >
        <SpeedDialAction
          key={"newGame"}
          icon={<Add />}
          tooltipTitle={"Neues Spiel"}
          onClick={handleOpenWizard}
        />
        <SpeedDialAction
          key={"emptyProtocol"}
          icon={<Description />}
          tooltipTitle={"Leeres Protokoll"}
          onClick={onCreateEmpty}
        />
        <SpeedDialAction
          key={"deleteEverything"}
          icon={<DeleteForever />}
          tooltipTitle={"Alles löschen"}
          onClick={handleOpenDeleteEverything}
        />
        {process.env.NODE_ENV === "development" && (
          <SpeedDialAction
            key={"testGames"}
            icon={<GppGood />}
            tooltipTitle={"Spiele validieren"}
            onClick={handleOpenValidation}
          />
        )}
      </SpeedDial>
      <CreateGameWizard
        open={openWizard}
        handleClose={handleCloseWizard}
        onCreateGame={(game, destination) => {
          handleCloseWizard();
          onCreateGame(game, destination);
        }}
      />

      <DeleteEverythingDialog
        open={openDeleteEverything}
        handleClose={handleCloseDeleteEverything}
      />

      {process.env.NODE_ENV === "development" && (
        <ValidateGamesDialog
          open={openValidation}
          handleClose={handleCloseValidation}
        ></ValidateGamesDialog>
      )}
    </>
  );
};

export default FabSpeeddial;
